import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTrigger,
} from '@/components/ui/dialog'
import EmailTemplatedMessageForm from '@/components/forms/email-templated-messages-form'
import { Icons } from '@/components/icons'

export const Route = createFileRoute('/_home/message-templates/email/add')({
  component: AddEmailTemplatedMessagesPage,
})

export default function AddEmailTemplatedMessagesPage() {
  const [showAddEmailTemplatedEmailModal, setShowAddEmailTemplatedEmailModal] =
    React.useState<boolean>(false)
  return (
    <main>
      {/*      <Dialog>
        <DialogTrigger asChild>
          <Button>
            <Icons.add className="size-4" />
            Add Email Templates
          </Button>
        </DialogTrigger>
        <DialogContent className="md:max-w-[850px]">
          <EmailTemplatedMessageForm />
          <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
            <DialogClose>
              <Button variant="outline" type="submit" className="w-28">
                Cancel
              </Button>
            </DialogClose>
            <Button type="submit" className="w-28">
              Add
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
      <div>
        <Button
          onClick={() => {
            {
              if (!validateUserAddPermission()) return
              setShowAddEmailTemplatedEmailModal(true)
            }
          }}
        >
          <Icons.add className="size-4" />
          Add Email Templates
        </Button>
      </div>
      <Credenza
        open={showAddEmailTemplatedEmailModal}
        onOpenChange={setShowAddEmailTemplatedEmailModal}
      >
        <CredenzaContent className="flex w-full max-w-[750px] justify-center">
          <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
            <EmailTemplatedMessageForm
              setShowAddEmailTemplatedEmailModal={
                setShowAddEmailTemplatedEmailModal
              }
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
